import type {FC} from "react";
import {memo, useCallback, useMemo} from "react";

import Tag from "../Tag";

import type {InputType, TagModel} from "./type";

type Props = {
    tag: TagModel;
    index: number;
    inputType: InputType;
    onClickTag: (index: number, tag: TagModel) => void;
    onClose: (tag: TagModel) => void;
};

const TagItem: FC<Props> = ({tag, index, inputType, onClickTag, onClose}) => {
    const tagValue = useMemo(() => {
        if (inputType === "phone") {
            return /^\+/.test(tag.value) ? tag.value : `+${tag.value}`;
        }
        return tag.value;
    }, [inputType, tag.value]);

    const handleClickTag = useCallback(() => {
        onClickTag(index, tag);
    }, [index, onClickTag, tag]);

    const handleClose = useCallback(() => {
        onClose(tag);
    }, [onClose, tag]);

    return (
        <Tag isInvalid={!tag.valid} onClose={handleClose} onPress={handleClickTag}>
            {tagValue}
        </Tag>
    );
};

export default memo(TagItem);
